exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.app[data-v-7ba5bd90] {\n  height: 100%;\n}\n.app .atlas_svg[data-v-7ba5bd90] {\n    display: inline;\n    width: 100%;\n    height: 100%;\n}\n.dbgbot[data-v-7ba5bd90] {\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?-url!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/App.vue
// module id = 22
// module chunks = 0